import { ScopeBySector } from '../scopes-types';

export const SCOPES_VENUE_STRUCTURE: ScopeBySector = {
  '': {},
  ANY: {},
  TEAM: {
    all: 'VENUE-STRUCTURE-TEAM',
    transport: 'VENUE-STRUCTURE-TEAM-TRANSPORT',
    catering: 'VENUE-STRUCTURE-TEAM-CATERING',
  },
  ARTISTS: {},
  SITE: {
    all: 'VENUE-STRUCTURE-SITE',
    scenography: 'VENUE-STRUCTURE-SITE-SCENOGRAPHY',
    material: 'VENUE-STRUCTURE-SITE-MATERIAL',
    building: 'VENUE-STRUCTURE-SITE-BUILDING',
    energy: 'VENUE-STRUCTURE-SITE-ENERGY',
    water: 'VENUE-STRUCTURE-SITE-WATER',
    waste: 'VENUE-STRUCTURE-SITE-WASTE',
    equipment: 'VENUE-STRUCTURE-SITE-EQUIPMENT',
  },
  PUBLIC: {
    all: 'VENUE-STRUCTURE-PUBLIC',
    catering: 'VENUE-STRUCTURE-PUBLIC-CATERING',
    digital: 'VENUE-STRUCTURE-PUBLIC-DIGITAL',
  },
};
